import {
  selectIsCampaignPerformanceAlertsFeatureFlagOn,
  selectIsEmbeddedMessagingCoreFeatureFlagOn,
} from 'core/userContext';
import { useSelector } from 'react-redux';
import { useWhatsAppMessageChannelFeature } from 'utils/hooks/featureFlags';
import { useCampaignFiltersContext } from '../campaignFolders/contexts/CampaignFiltersContext';
import { flattenFilters } from '../utils';

export const useFlattenedFilters = () => {
  const isEmbeddedMessagingEnabled = useSelector(selectIsEmbeddedMessagingCoreFeatureFlagOn);
  const isCampaignAlertsOn = useSelector(selectIsCampaignPerformanceAlertsFeatureFlagOn);
  const { isWhatsAppEnabled: isWhatsAppOn } = useWhatsAppMessageChannelFeature();

  const {
    alerts,
    campaignTypes,
    channelTypes,
    creators,
    labels,
    lists,
    media,
    modifiers,
    placements,
    states,
    templateType,
    templateStatus,
    templateQualityRating,
  } = useCampaignFiltersContext();

  /**
   * This has to be in the same order as the filters are listed in the campaign index
   */
  const selectedFilters = [
    labels,
    media,
    campaignTypes,
    channelTypes,
    lists,
    states,
    ...(isCampaignAlertsOn ? [alerts] : []),
    creators,
    modifiers,
    ...(isWhatsAppOn ? [templateType, templateStatus, templateQualityRating] : []),
    ...(isEmbeddedMessagingEnabled ? [placements] : []),
  ];

  return flattenFilters(
    selectedFilters,
    isEmbeddedMessagingEnabled,
    isCampaignAlertsOn,
    isWhatsAppOn,
  );
};
